export default "https://cdn-web.disco.co/disco-badge-bfc15a408bdc692dcc084b60d51ce614.png";